export const urls = {
  home: '/dashboard',
  dashboard: '/dashboard',
  workers: '/workers',
  applications: '/application',
  matchingProfile: '/matching-profile',
  sharedProfile: '/shared-profile',
  trackOnboarding: '/track-onboard',
  financial: '/financial',
  agencyReport: '/dashboard',
  agencyProfile: '/profile/contactInfo',
  contactSupport: '/dashboard',
  faqs: '/faq',
  agencyReviewRating: '/review-rating',
  agencyServices: '/services'
};
